/**
 * 静态资源管理工具
 * 用于统一管理 static 目录下的图片资源
 */

// 获取静态资源的完整路径
export const getStaticAsset = (path) => {
  // 确保路径以 / 开头
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `/static${normalizedPath}`;
};

// 常用的静态资源路径
export const STATIC_ASSETS = {
  // Logo
  LOGO: getStaticAsset('/logo.png'),
  Our_Vision: getStaticAsset('/Our_Vision.png'),
    Vector: getStaticAsset('/Vector.png'),
    Line_x: getStaticAsset('/Line_x.png'),
    bg01: getStaticAsset('/bg01.png'),
    bg02: getStaticAsset('/bg02.png'),
    bg03: getStaticAsset('/bg03.png'),
    page03: getStaticAsset('/page03.png'),
    page04: getStaticAsset('/page04.png'),
    page05: getStaticAsset('/page05.png'),
    page06: getStaticAsset('/page06.png'),
    page07: getStaticAsset('/page07.png'),
      page09: getStaticAsset('/page09.png'),
};

// 检查图片是否加载成功的工具函数
export const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};

// 批量预加载图片
export const preloadImages = async (imagePaths) => {
  try {
    const promises = imagePaths.map(path => preloadImage(path));
    await Promise.all(promises);
    console.log('所有图片预加载完成');
  } catch (error) {
    console.error('图片预加载失败:', error);
  }
};